import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
import { DvonnRules } from './DvonnRules';
export class DvonnMaxStacksHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const state = node.gameState;
        // The metric is percentage of the stacks controlled by the player
        const scores = DvonnRules.getScores(state);
        const metrics = new PlayerNumberTable();
        const pieces = state.getAllPieces();
        const numberOfStacks = pieces.length;
        for (const player of Player.PLAYERS) {
            const playerStacks = pieces.filter((c) => state.getPieceAt(c).belongsTo(player)).length;
            const oldScore = scores.get(player);
            metrics.set(player, [oldScore * playerStacks / numberOfStacks]);
        }
        return metrics;
    }
}
